import { Store, Module, ActionContext } from "vuex";
import ListModule from "./list-module";
import ListState from "./list-state";
import Location from "../entities/location";
import Ajax from "../../lib/ajax";
import appconst from './../../lib/appconst';
import LocationItems from "../entities/locationItems";
import PageResult from '@/store/entities/page-result';
interface LocationState extends ListState<Location> {
  item: Location;
  viewLocation: LocationItems;
}
class LocationModule extends ListModule<LocationState, any, Location> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Location>(),
    loading: false,
    item: new Location(),
    viewLocation: new LocationItems(),
  };
  actions = {
    async getLocation(
      context: ActionContext<LocationState, any>,
      payload: any
    ) {
      context.state.loading = true;
      const {
        data: { result, success }
      } = await Ajax.get("/api/services/app/Location/ViewLocation", {
        params: payload.data
      });
      const page = result.items as PageResult<LocationItems>;
      context.state.totalCount = page.totalCount;
      context.state.item = result;
      context.state.item.items = page.items;
      context.state.loading = false;
    },
    async searchLocationContainProduct(
      context: ActionContext<LocationState, any>,
      payload: any
    ) {
      context.state.loading = true;
      const {
        data: { result, success }
      } = await Ajax.get("/api/services/app/Location/SearchLocationContainProduct", {
        params: payload.data
      });
      context.state.loading=false;
      return result;
    },
    async getLocationProductOrCaseLabelSerials(
      context: ActionContext<LocationState, any>,
      payload: any
    ) {
      context.state.loading = true;
      const {
        data: { result, success }
      } = await Ajax.get("/api/services/app/Location/GetLocationProductOrCaseLabelSerials", {
        params: payload.data
      });
      context.state.loading=false;
      return result;
    },
    async exportProducLocation(context:ActionContext<LocationState,any>,payload:any){
      var url = `${appconst.remoteServiceBaseUrl}export/ExportProducLocation${abp.utils.buildQueryString(Object.keys(payload.data).map((key) => {
          return {
              name: key,
              value: payload.data[key]
          }
      }), true)}`;
      window.open(url, "_blank");    
    } ,
    async exportViewLocation(context:ActionContext<LocationState,any>,payload:any){
      var url = `${appconst.remoteServiceBaseUrl}export/ExportViewLocation${abp.utils.buildQueryString(Object.keys(payload.data).map((key) => {
          return {
              name: key,
              value: payload.data[key]
          }
      }), true)}`;
      window.open(url, "_blank");    
    } ,
  };

  mutations = {
    setCurrentPage(state: LocationState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: LocationState, pagesize: number) {
      state.pageSize = pagesize;
    },
    view(state: LocationState, locationItem: LocationItems) {
      state.viewLocation = locationItem;
    }
  };
}
const locationModule = new LocationModule();
export default locationModule;
